import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-dashboard-list-card-skeleton',
  imports: [Skeleton],
  templateUrl: './dashboard-list-card-skeleton.html',
})
export class DashboardListCardSkeleton {}
